export interface Options {
  label?: string;
  value: string;
}

const getLabelValue = (
  dataSource: object[],
  value: string | number | Options | any,
  options: Options = { value: 'value', label: 'label' },
) => {
  const el = dataSource.find((i: Options) => {
    return i[options.value] === value;
  });
  return el || value;
};

export { getLabelValue };
